export default __webpack_public_path__ + "static/media/901.92444029.png";